import React, { memo, useCallback, useEffect } from 'react';
import { Button } from 'appkit-react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import '@style/modules/project/dealComplexity.scss';
import '../../../../styles/modules/project/dealComplexity.scss';
import GaugeChart from '@components/gaugeChart';
import GaugeCard, {
  SECTION_LEVEL_PREFIX,
  SECTION_SUMMARY_PREFIX,
} from '@modules/questionnaires/complexity/sections/overall/components/gaugeCard';
import { Form } from 'antd';
import { findSectionData } from '@modules/questionnaires/complexity/sections/overall/overall';
// import { SectionComment } from '@components/CommentCenter';
// import CommentAnchor from '@components/directUser/CommentAnchor';
import { shouldScrollInToView } from '@components/directUser/utils';
import SectionComment from 'src/ddvComment/SectionComment';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import { projectRole, QUES_SECTIONS_KEYS } from '@model';
import { setSessionStorage } from '@utils/windowUtil';

const DealComplexity = (props) => {
  const {
    // id,
    complexityData = {},
    isPwcReadOnly,
    titleName,
    questionnaireModuleVisible,
  } = props;
  const history = useHistory();
  // const texts = [
  //   { name: 'Strategy' },
  //   { name: 'Value' },
  //   { name: 'Enterprise' },
  //   { name: 'People' },
  //   { name: 'Execution' },
  // ];
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  const isClient = JSON.parse(window.localStorage.userInfo || '{}').isClient;
  const [form] = Form.useForm();
  // const dispatch = useDispatch();

  useEffect(() => {
    const nextFormData = {};
    if (Array.isArray(complexityData?.sectionComplexity)) {
      complexityData.sectionComplexity.forEach((sectionItem) => {
        nextFormData[`${SECTION_LEVEL_PREFIX}${sectionItem.seqNum}`] =
          sectionItem.levelPercent;
        nextFormData[`${SECTION_SUMMARY_PREFIX}${sectionItem.seqNum}`] =
          sectionItem.summary;
      });
      form.setFieldsValue(nextFormData);
    }

    return () => {
      form.resetFields();
    };
  }, [complexityData?.sectionComplexity]);

  const onClickPlaceholder = useCallback(() => {
    setSessionStorage('editMode', true);
    history.push({
      pathname: '/questionnaires/complexity',
    });
  }, []);

  const dealComplexityBtnText = () => {
    let text = '';
    if (isInternal) {
      complexityData?.status === 0
        ? (text = 'start questionnaire')
        : (text = 'go to report');
    } else {
      text = 'go to report';
    }
    return text;
  };
  const buttonVisible =
    (isInternal && !isPwcReadOnly) ||
    (isInternal &&
      isPwcReadOnly &&
      questionnaireModuleVisible &&
      complexityData?.status > 1) ||
    (isClient && questionnaireModuleVisible && complexityData?.status > 1);
  return (
    <div className="complexity-box">
      <div className="complexity-head">
        <div className="title">{titleName ? titleName : 'Deal complexity'}</div>
        <div className="button-with-comment-icon">
          <SectionComment
            module="Project Home"
            component="Deal Complexity"
            placement="leftTop"
            sendIdentifier="complexity"
            getPopupContainer={() =>
              document.getElementsByClassName('complexity-head')[0]
            }
          />
          {!buttonVisible
            ? null
            : (complexityData?.status < 1 || complexityData?.status > 2) && (
                <Button
                  className="btn"
                  style={{ textTransform: 'capitalize' }}
                  onClick={() => {
                    let whichToGo = '/questionnaires/welcome';
                    if (complexityData?.status === 1) {
                      whichToGo = '/questionnaires/strategy';
                    } else if (complexityData?.status === 2) {
                      whichToGo = '/questionnaires/review-responses';
                    } else if (complexityData?.status === 3) {
                      whichToGo = '/questionnaires/complexity';
                    }
                    history.push({
                      pathname: whichToGo,
                      // state: { id },
                    });
                  }}
                >
                  {dealComplexityBtnText()}
                </Button>
              )}
        </div>
      </div>
      <Form className="complexity-chart" form={form}>
        <GaugeChart
          size="big"
          background="#1d1d1d"
          value={complexityData?.overallComplexity?.levelPercent}
        />
        <GaugeCard
          title={QUES_SECTIONS_KEYS.StrategyValue}
          seqNum={1}
          gaugeBackground="#262626"
          isEditing={false}
          cardData={findSectionData(complexityData?.sectionComplexity, 1)}
          onClickPlaceholder={onClickPlaceholder}
        />
        <GaugeCard
          title={QUES_SECTIONS_KEYS.OrganizationPeople}
          seqNum={2}
          gaugeBackground="#262626"
          cardData={findSectionData(complexityData?.sectionComplexity, 2)}
          onClickPlaceholder={onClickPlaceholder}
        />
        <GaugeCard
          title={QUES_SECTIONS_KEYS.EnterpriseIntegrationConsiderations}
          seqNum={3}
          gaugeBackground="#262626"
          cardData={findSectionData(complexityData?.sectionComplexity, 3)}
          onClickPlaceholder={onClickPlaceholder}
        />
      </Form>
    </div>
  );
};

const mapStateToProps = ({ projects, common }) => ({
  // complexityPermission:
  //   projects?.sectionsPermission?.questionnairePermission?.includes(
  //     'complexity',
  //   ),
  // internalComplexityPermission:
  //   projects?.internalSectionsPermission?.questionnairePermission?.includes(
  //     'complexity',
  //   ),
  questionnaireModuleVisible:
    projects?.originAccessibleModules?.moduleList?.includes('complexity'),
  isPwcReadOnly:
    common?.projectCompanyInfo?.currentUserPermission ===
    projectRole['View-Only'],
});

export default connect(
  mapStateToProps,
  null,
)(
  memo(
    CommentAnchor(DealComplexity, {
      shouldScrollInToView,
      initialAnchorId: 'complexity',
    }),
  ),
);
